import React from 'react';
import { DownloadCsvComponent } from '../../../atomic/buttons/downloadCSV/DownloadCsvComponent';
import { timeFormat } from 'd3-time-format';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { colors } from '../../../../colorVars';
import { timeStampTo24HourEST } from '../../../../stores/websocketStore/utils/mungingUtils/timeFormatting/timeStampTo24HourEST';
import { getNotificationSymbol } from '../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationSymbol';
import { getNotificationType } from '../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationType';
import { getNotificationStatusComponent } from '../../../../stores/websocketStore/utils/mungingUtils/notifications/higherOrderHandlers/getNotificationStatusComponent';
import * as ReactDOMServer from 'react-dom/server';

export const ExportLogs = observer(() => {
  const { activityLogsStore } = useWebsocketStore();
  const headers = [
    { label: 'Time', key: 'date' },
    { label: 'Symbol', key: 'symbol' },
    { label: 'Type', key: 'type' },
    { label: 'Notification', key: 'notification' },
  ];
  const formatDate = timeFormat('%m-%d-%Y');
  const formattedToday = formatDate(new Date());
  const data = Object.values(activityLogsStore.logs).map((log) => {
    const symbol = getNotificationSymbol(log) ?? 'N/A';
    const { text } = getNotificationType(log);
    const [StatusComponent, parsedStatusObj] = getNotificationStatusComponent(
      log
    ) ?? [null, null];
    const string = StatusComponent
      ? ReactDOMServer.renderToString(
          <StatusComponent parsedStatusObj={parsedStatusObj} />
        ).replace(/<[^>]*>/g, '')
      : '';

    const time = timeStampTo24HourEST(log.timestamp);
    return {
      date: time,
      symbol,
      notification: string,
      type: text,
    };
  });
  return (
    <div>
      <DownloadCsvComponent
        headers={headers}
        data={data}
        filename={`logs_${formattedToday}.csv`}
        size="15px"
        backgroundColor={colors.blue}
        // margin="5px 0 0 10px"
      />
    </div>
  );
});

/* 
{
    "1644866551856": {
        "messageType": "notifications",
        "id": 1644866551856,
        "tradePlanId": 1644867043450,
        "notification": "System has been terminated",
        "severityScore": "info",
        "symbol": "TSLA",
        "date": "2022-02-14T14:31:08.082-0500"
    },
    "1644866551851": {
        "messageType": "notifications",
        "id": 1644866551851,
        "tradePlanId": 1644867043448,
        "notification": "Plan realizedPnl: 2. Position realizedPnl: 2.3",
        "severityScore": "info",
        "symbol": "AAPL",
        "date": "2022-02-14T14:31:04.863-0500"
    },
    "1644866551853": {
        "messageType": "notifications",
        "id": 1644866551853,
        "tradePlanId": 1644867043449,
        "notification": "Plan realizedPnl: 0. Position realizedPnl: 0.67",
        "severityScore": "info",
        "symbol": "AMD",
        "date": "2022-02-14T14:31:07.157-0500"
    },
    "1644866551852": {
        "messageType": "notifications",
        "id": 1644866551852,
        "tradePlanId": 1644867043448,
        "notification": "System has been terminated",
        "severityScore": "info",
        "symbol": "AAPL",
        "date": "2022-02-14T14:31:04.916-0500"
    },
    "1644866551855": {
        "messageType": "notifications",
        "id": 1644866551855,
        "tradePlanId": 1644867043450,
        "notification": "Plan realizedPnl: -1. Position realizedPnl: -1.2",
        "severityScore": "info",
        "symbol": "TSLA",
        "date": "2022-02-14T14:31:08.060-0500"
    },
    "1644866551854": {
        "messageType": "notifications",
        "id": 1644866551854,
        "tradePlanId": 1644867043449,
        "notification": "System has been terminated",
        "severityScore": "info",
        "symbol": "AMD",
        "date": "2022-02-14T14:31:07.180-0500"
    }
}
*/
